var map = {
	"./bags.jpg": "93cc",
	"./block.jpg": "c9a6",
	"./cleaning.jpg": "2a67",
	"./container.jpg": "fbfc",
	"./for_road.png": "5a76",
	"./for_road2.png": "b081",
	"./receipt_engine-2023-01.jpg": "9b65",
	"./to_podosinki.jpg": "36a1",
	"./water-2-0.png": "1c3b",
	"./water-2-1.png": "0e50",
	"./water-pump-2.png": "963e",
	"./water-pump-3.jpg": "7118",
	"./water-pump.png": "9fdd",
	"./water.jpg": "e3d7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "db35";